export function PageContainer({ children } : { children: React.ReactNode }) {
  return <div style={{ padding: '0 0.5rem' }}>
    { children }
  </div>
}